import { gql } from '@apollo/client';
import { AccountDeliveryDriverType } from '../../types/AccountDeliveryDriverType';

export const GET_ACCOUNT_DELIVERY_DRIVER_LISTING = gql`
    query GetAccountDeliveryDriverListing($filter: AccountDeliveryDriverFiltersTypeInput, $pageRequest: PageRequestTypeInput) {
        getAccountDeliveryDriverListing(filters: $filter, pageRequest: $pageRequest) {
            content {
                id
                accountId
                dspId
                driverLicenseNumber
                vehicleTypeId
                vehiclePlate
                isOnDuty
                isBlacklist
                isEmployed
                vehicleImageS3KeysJson
                vehicleImageUrls
                verificationStatus
                verificationTime
                reviewComment
                idDocumentType
                idDocumentNumber
                idDocumentImageS3KeysJson
                idDocumentImageUrls
                createdAt
                updatedAt
                account {
                    id
                    name
                    countryCode
                    phone
                    email
                    status
                    phoneStatus
                }
                dsp {
                    id
                    name
                    dspCode
                }
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface AccountDeliveryDriverFiltersTypeInput {
    name?: string | null;
    phone?: string | null;
    email?: string | null;
    vehiclePlate?: string | null;
    dspId?: number | null;
    warehouseId?: number | null;
    verificationStatus?: number | null;
    idDocumentType?: number | null;
    idDocumentNumber?: string | null;
    isBlacklist?: boolean | null;
}

// 使用通用的 PageRequestTypeInput，定义在 graphql/types/settlement/CommonTypes.ts

export interface AccountDeliveryDriverListingResponse {
    getAccountDeliveryDriverListing: AccountDeliveryDriverListingResponseType;
}

export interface AccountDeliveryDriverListingResponseType {
    content: AccountDeliveryDriverType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

